export default {
  setAccountConfig(state, data) {
    state.accountConfig = data;
  },

  setTaxTable(state, data) {
    state.taxTable = data;
  },

  setTaxTableById(state, data) {
    state.taxTableById = data;
  },

  setTaxTableIsValid(state, data) {
    state.taxTableIsValid = data;
  },

  setTaxTableLastRecord(state, data) {
    state.taxTableLastRecord = data;
  },

  setOccupationCategory(state, data) {
    state.occupationCategory = data;
  },

  setOccupationCategoryById(state, data) {
    state.occupationCategoryById = data;
  },

  setOccupationCategoryCode(state, data) {
    state.occupationCategoryCode = data;
  },

  setNationalityType(state, data) {
    state.nationalityType = data;
  },

  setNationalityTypeById(state, data) {
    state.nationalityTypeById = data;
  },

  setNationalityTypeCode(state, data) {
    state.nationalityTypeCode = data;
  },

  setWorkPlaceStatus(state, data) {
    state.workPlaceStatus = data;
  },

  setWorkPlaceStatusById(state, data) {
    state.workPlaceStatusById = data;
  },

  setWorkPlaceStatusCode(state, data) {
    state.workPlaceStatusCode = data;
  },

  setExemptionType(state, data) {
    state.exemptionType = data;
  },

  setExemptionTypeById(state, data) {
    state.exemptionTypeById = data;
  },

  setExemptionTypeCode(state, data) {
    state.exemptionTypeCode = data;
  },

  setExcelSample(state, data) {
    state.excelSample = data;
  },

  setExcelSampleById(state, data) {
    state.excelSampleById = data;
  },

  setExcelSampleMaxColumnIndex(state, data) {
    state.excelSampleMaxColumnIndex = data;
  },

  setExcelSampleDetail(state, data) {
    state.excelSampleDetail = data;
  },

  setExcelSampleId(state, data) {
    state.excelSampleId = data;
  },

  setExcelSampleData(state, data) {
    state.excelSampleData = data;
  },

  setBenefitsAndDeduction(state, data) {
    state.benefitsAndDeduction = data;
  },

  setBenefitsAndDeductionCode(state, data) {
    state.benefitsAndDeductionCode = data;
  },

  setBenefitsAndDeductionPriority(state, data) {
    state.benefitsAndDeductionPriority = data;
  },

  setBenefitsAndDeductionById(state, data) {
    state.benefitsAndDeductionById = data;
  },

  setInsuranceWorkplace(state, data) {
    state.insuranceWorkplace = data;
  },

  setInsuranceWorkplaceById(state, data) {
    state.insuranceWorkplaceById = data;
  },

  setInsuranceWorkplaceCode(state, data) {
    state.insuranceWorkplaceCode = data;
  },

  setSettings(state, data) {
    state.settings = data;
  },

  setEmployeePortalAccess(state, data) {
    state.employeePortalAccess = data;
  },

  setWorkingHours(state, data) {
    state.workingHours = data;
  },

  setWorkingHourById(state, data) {
    state.workingHourById = data;
  },

  setAgreementRows(state, data) {
    state.agreementRows = data;
  },

  setAgreementRowById(state, data) {
    state.agreementRowById = data;
  },

  setAgreementRowCode(state, data) {
    state.agreementRowCode = data;
  },

  setJobGroups(state, data) {
    state.jobGroups = data;
  },

  setJobGroupById(state, data) {
    state.jobGroupById = data;
  },

  setJobGroupCode(state, data) {
    state.jobGroupCode = data;
  },

  setContractTypes(state, data) {
    state.contractTypes = data;
  },
  setContractTypeById(state, data) {
    state.contractTypeById = data;
  },
  setContractTypeCode(state, data) {
    state.contractTypeCode = data;
  },

  setAdditionalContractParameters(state, data) {
    state.additionalContractParameters = data;
  },

  setParameterValues(state, data) {
    state.parameterValues = data;
  },

  setContractSamples(state, data) {
    state.contractSamples = data;
  },
  setContractSampleById(state, data) {
    state.contractSampleById = data;
  },
  setContractSampleCode(state, data) {
    state.contractSampleCode = data;
  },
  setContractSampleId(state, data) {
    state.contractSampleId = data;
  },
  setContractSampleNavigation(state, data) {
    state.contractSampleNavigation = data;
  },

  setContracts(state, data) {
    state.contracts = data;
  },
  setContractById(state, data) {
    state.contractById = data;
  },
  setContractCode(state, data) {
    state.contractCode = data;
  },
  setContractId(state, data) {
    state.contractId = data;
  },
  setContractNavigation(state, data) {
    state.contractNavigation = data;
  },

  setFormulas(state, data) {
    state.formulas = data;
  },
  setFormulaById(state, data) {
    state.formulaById = data;
  },
  setFormulaId(state, data) {
    state.formulaId = data;
  },
  setFormulaCode(state, data) {
    state.formulaCode = data;
  },
  setFormulaPriority(state, data) {
    state.formulaPriority = data;
  },

  setPayrollEmployees(state, data) {
    state.payrollEmployees = data;
  },
  setPayrollEmployee(state, data) {
    state.payrollEmployee = data;
  },
  setPayrollEmployeeContracts(state, data) {
    state.payrollEmployeeContracts = data;
  },
  setPayrollEmployeeVoucher(state, data) {
    state.payrollEmployeeVoucher = data;
  },
  setPayrollEmployeePayment(state, data) {
    state.payrollEmployeePayment = data;
  },
  setPayrollEmployeeDirectVoucher(state, data) {
    state.payrollEmployeeDirectVoucher = data;
  },
  setPayrollEmployeeNavigation(state, data) {
    state.payrollEmployeeNavigation = data;
  },
  setPayrollEmployeeCalculate(state, data) {
    state.payrollEmployeeCalculate = data;
  },
  setPayrollEmployeeImportPreview(state, data) {
    state.payrollEmployeeImportPreview = data;
  },

  setTaxRateTypes(state, data) {
    state.taxRateTypes = data;
  },

  setPrintLink(state, data) {
    state.printLink = data;
  },

  setPayrollEmployeeReport(state, data) {
    state.payrollEmployeeReport = data;
  },

  setEmployeePayrollSummaryPersonnelReport(state, data) {
    state.employeePayrollSummaryPersonnelReport = data;
  },

  setEmployeePayrollSummaryPersonnelDetail(state, data) {
    state.employeePayrollSummaryPersonnelDetail = data;
  },

  setPayrollEmployeeSummaryReport(state, data) {
    state.payrollEmployeeSummaryReport = data;
  },

  setPayrollEmployeeSummaryInsuranceWorkplaceReport(state, data) {
    state.payrollEmployeeSummaryInsuranceWorkplaceReport = data;
  },

  setAdvanceReport(state, data) {
    state.advanceReport = data;
  },

  setPayslipReport(state, data) {
    state.payslipReport = data;
  },

  setInsuranceEmployees(state, data) {
    state.insuranceEmployees = data;
  },
  setInsuranceEmployee(state, data) {
    state.insuranceEmployee = data;
  },
  setInsuranceEmployeeId(state, data) {
    state.insuranceEmployeeId = data;
  },
  setInsuranceEmployeeContracts(state, data) {
    state.insuranceEmployeeContracts = data;
  },
  setInsuranceEmployeeNavigation(state, data) {
    state.insuranceEmployeeNavigation = data;
  },

  setTaxEmployees(state, data) {
    state.taxEmployees = data;
  },
  setTaxEmployee(state, data) {
    state.taxEmployee = data;
  },
  setTaxEmployeeId(state, data) {
    state.taxEmployeeId = data;
  },
  setTaxEmployeeContracts(state, data) {
    state.taxEmployeeContracts = data;
  },
  setTaxEmployeeNavigation(state, data) {
    state.taxEmployeeNavigation = data;
  },

  setLeaves(state, data) {
    state.leaves = data;
  },
  setLeaveById(state, data) {
    state.leaveById = data;
  },
  setLeaveCode(state, data) {
    state.leaveCode = data;
  },
  setLeaveNavigation(state, data) {
    state.leaveNavigation = data;
  },
  setLeaveConfirm(state, data) {
    state.leaveConfirm = data;
  },
  setLeaveManagementCartable(state, data) {
    state.leaveManagementCartable = data;
  },
  setMissions(state, data) {
    state.missions = data;
  },
  setMissionById(state, data) {
    state.missionById = data;
  },
  setMissionCode(state, data) {
    state.missionCode = data;
  },
  setMissionNavigation(state, data) {
    state.missionNavigation = data;
  },
  setMissionConfirm(state, data) {
    state.missionConfirm = data;
  },
  setMissionManagementCartable(state, data) {
    state.missionManagementCartable = data;
  },

  setAdvances(state, data) {
    state.advances = data;
  },
  setAdvanceById(state, data) {
    state.advanceById = data;
  },
  setAdvanceCode(state, data) {
    state.advanceCode = data;
  },
  setAdvanceId(state, data) {
    state.advanceId = data;
  },
  setAdvanceNavigation(state, data) {
    state.advanceNavigation = data;
  },
  setAdvanceConfirm(state, data) {
    state.advanceConfirm = data;
  },
  setAdvanceManagementCartable(state, data) {
    state.advanceManagementCartable = data;
  },
  setCartableLog(state, data) {
    state.cartableLog = data;
  },
  setAdvanceVoucher(state, data) {
    state.advanceVoucher = data;
  },
  setAdvanceVoucherId(state, data) {
    state.advanceVoucherId = data;
  },
  setAdvanceVoucherNumber(state, data) {
    state.advanceVoucherNumber = data;
  },

  setBankExportTemplates(state, data) {
    state.bankExportTemplates = data;
  },
  setBankExportTemplateById(state, data) {
    state.bankExportTemplateById = data;
  },
  setBankExportTemplateCode(state, data) {
    state.bankExportTemplateCode = data;
  },
  setBankExportTemplateId(state, data) {
    state.bankExportTemplateId = data;
  },
  setBankExportTemplateDeleteError(state, data) {
    state.bankExportTemplateDeleteError = data;
  },
  setBankExportVariables(state, data) {
    state.bankExportVariables = data;
  },
  setBankExportPreview(state, data) {
    state.bankExportPreview = data;
  },
  setBankExportError(state, data) {
    state.bankExportError = data;
  },
  setBankExportHistory(state, data) {
    state.bankExportHistory = data;
  },
  setBankExportHistoryDetail(state, data) {
    state.bankExportHistoryDetail = data;
  },
  setBankExportPayrolls(state, data) {
    state.bankExportPayrolls = data;
  },

  setPayroll(state, data) {
    state.payroll = data;
  },
};
